import React, { useState, useEffect } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import styles from '../styles/Blog.module.css';

function Blog() {
  const [posts, setPosts] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // The index loads ONLY this manifest (one request) — title, dek, date, image
  // and a search blob for every post. Full bodies are fetched on /blog/:slug.
  useEffect(() => {
    const fetchPosts = async () => {
      const res = await fetch('/posts/manifest.json');
      setPosts(await res.json());
    };
    fetchPosts();
  }, []);

  // Backward compatibility: old shared links used /blog?post=slug. Redirect
  // those to the new /blog/:slug route so they keep working.
  useEffect(() => {
    const legacy = searchParams.get('post');
    if (legacy) navigate(`/blog/${legacy}`, { replace: true });
  }, [searchParams, navigate]);

  const term = searchTerm.toLowerCase();
  const matches = (post) =>
    !term ||
    [post.title, post.dek, post.search]
      .filter(Boolean)
      .some((field) => field.toLowerCase().includes(term));

  return (
    <div className={styles.blogContainer}>
      <h1 className={styles.title}>Some writing</h1>

      {/* Search Bar */}
      <div className={styles.searchContainer}>
        <input
          type="text"
          placeholder="Find a post"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className={styles.searchBar}
        />
      </div>

      {/* Blog Posts */}
      <div className={styles.postsContainer}>
        {posts.filter(matches).map((post) => (
          <div key={post.slug} className={styles.post}>
            <h2 className={styles.postTitle}>{post.title}</h2>
            <p className={styles.dek}>{post.dek}</p>
            <p className={styles.date}>{post.date}</p>
            {post.image && (
              <img
                src={post.image}
                alt={post.alt || post.title}
                className={styles.postImage}
              />
            )}
            <Link to={`/blog/${post.slug}`} className={styles.toggleButton}>
              Read it
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Blog;
